const PaymentDataHelper = function (UserControl) {
    var service = {};

    service.factory = function ($scope) {
        $scope.checkPaymentForm = function () {
            var formID = 'register-form-debit';
            var formObj = document.getElementById(formID);
            var valid = $scope.checkIban() && formObj.checkValidity();
            $scope.paymentDataValid = valid;
            return valid;
        };

        $scope.checkIban = function () {
            let ibanValue = $scope.debit.iban;
            const ibanInput = document.getElementById('debit_iban');
            const isIbanValid = IBAN.isValid(ibanValue);

            if (!ibanValue || !isIbanValid) {
                if (typeof $scope.translations[ 'custom' ] === "undefined" || typeof $scope.translations[ 'custom' ][ 'please_enter_valid_iban' ] === "undefined") {
                    $scope.translations[ 'custom' ] = translations;
                }
                ibanInput.setCustomValidity($scope.translations[ 'custom' ][ 'please_enter_valid_iban' ]);
                return false;
            }

            ibanInput.setCustomValidity('');
            return true;
        };

        $scope.loadPaymentData = function () {
            $scope.debit.editable = true;
            if (UserControl.customer.id && UserControl.customer.status !== 3) {
                let postBoxDocument = $scope.projectName + '-' + UserControl.customer.id;

                postboxHelper.get('/postbox/CustomerPaymentData?document=' + postBoxDocument, function (response, request) {
                    if (!response.error) {
                        // Zahlungsdaten zum Customer wurden aus der Postbox geladen
                        // Initial sind die Textfelder nicht editierbar (editable)
                        // Bei Speichern der Daten muss das Postbox Dokument überschrieben werden statt ein neues anzulegen (overwrite)
                        $scope.debit.accountOwner = response.accountOwner;
                        $scope.debit.iban = response.iban;
                        $scope.debit.bic = response.bic;
                        $scope.debit.editable = false;
                        $scope.debit.overwrite = true;
                        $scope.debit.accept = true;
                    } else {
                        $scope.debit.iban = '';
                        $scope.debit.bic = '';
                        $scope.debit.editable = true;
                        $scope.debit.overwrite = false;
                        $scope.debit.accept = false;
                    }
                    $scope.checkCheckoutPossible();
                });
            }
        };

        $scope.setEditable = function () {
            if (UserControl.customer.status !== 3) {
                $scope.debit.iban = '';
                $scope.debit.bic = '';
            }
            $scope.debit.editable = true;
            $scope.checkCheckoutPossible();
        };

        $scope.updatePaymentData = function () {
            let valid = $scope.checkPaymentForm();
            if (!valid) {
                var formID = 'register-form-debit';
                var formObj = document.getElementById(formID);
                formObj.reportValidity();
            } else {

                if (UserControl.customer.status === 3 && !$scope.formStatus.registerForPaymentMode && !$scope.formStatus.loginForPaymentMode) {
                    $scope.debit.editable = false;
                    $scope.checkCheckoutPossible();
                    return;
                }

                let postBoxDocument = $scope.projectName + '-' + UserControl.customer.id;
                let encodedIban = '';
                if ($scope.debit.iban.length > 0) {
                    encodedIban = '***' + $scope.debit.iban.substr($scope.debit.iban.length - 4, 4);
                }

                let ibanCustomer = {
                    'customerId': UserControl.customer.id,
                    'encodedIban': encodedIban
                };
                $scope.ajaxCall('purchase', 'saveibantocustomer', 'POST', ibanCustomer,
                    function (response) {
                        if (!response.status) {
                            $scope.displayError(response.message);
                        }
                    });

                let postData = {
                    'dbName': 'customerdata',
                    'document': postBoxDocument,
                    'data': {
                        'shop': $scope.projectName,
                        'accountOwner': $scope.debit.accountOwner,
                        'bic': $scope.debit.bic,
                        'iban': $scope.debit.iban,
                    }
                };
                if ($scope.debit.overwrite) {
                    postboxHelper.patch('/carrier/' + postBoxDocument + '/document/', postData, function (response, request) {
                        $scope.loadPaymentData();
                    });
                } else {

                    postboxHelper.put('/carrier/document/', postData, function (response, request) {
                        $scope.loadPaymentData();
                    });
                }
            }
            $scope.checkCheckoutPossible();

        };

        $scope.registerForPaymentData = function () {
            let valid = $scope.checkPaymentForm();
            if (!valid) {
                var formID = 'register-form-debit';
                var formObj = document.getElementById(formID);
                formObj.reportValidity();
            } else {
                $scope.formStatus.userLoggedIn = false;
                $scope.formStatus.guestLoggedIn = false;
                $scope.formStatus.registerMode = true;
                $scope.formStatus.loginMode = false;
                $scope.formStatus.updateMode = false;
                $scope.formStatus.registerForPaymentMode = true;
                $scope.formStatus.loginForPaymentMode = false;
                $scope.debit.editable = false;
                $scope.scrollTo('#register');
            }
        };

        $scope.goToLogin = function () {
            $scope.formStatus.userLoggedIn = false;
            $scope.formStatus.guestLoggedIn = false;
            $scope.formStatus.registerMode = false;
            $scope.formStatus.loginMode = true;
            $scope.formStatus.updateMode = false;
            $scope.formStatus.loginForPaymentMode = true;
            $scope.formStatus.registerForPaymentMode = false;
            $scope.scrollTo('#register');
        };
    };

    return service;
};

export default PaymentDataHelper;